'use strict';
import controller from './tableGridAccordionRow.controller';

let tableGridAccordionRowComponent = ($compile, $timeout) => {
  return {
    replace: false,
    scope: {
      row: '=',
      columns: '=',
      options: '=',
      metaData: '=',
      rowOptions: '='
    },
    controller,
    controllerAs: 'vm',
    link: {
      pre: (scope, el) => {
        scope.vm = scope;
        let templateString = '';

        scope.columns.forEach((column) => {

          if (column.type) {
            templateString += `<td><${column.type} show-drawer='showDrawer' row='vm.row' meta-data ='vm.metaData' options ='vm.options' columns='vm.columns' column-name='${column.name}'></${column.type}></td>`;
          }
        });

        let drawerString = `<tr class="table__table-row tableGridAccordionRow__panel" ng-class="{'tableGridAccordionRow__show': showDrawer }"><td class="${scope.vm.rowOptions.drawerClass}" colspan="${scope.columns.length}"><${scope.vm.rowOptions.drawerComponent} row="vm.row"></${scope.vm.rowOptions.drawerComponent}></td></tr>`;
        let rowElements = $compile(angular.element(templateString))(scope);
        el.append(rowElements);

        $timeout(() => {
          let drawer = $compile(angular.element(drawerString))(scope);
          el.after(drawer);

        });


      }
    }
  };
};

tableGridAccordionRowComponent.$inject = ['$compile', '$timeout'];

export
default tableGridAccordionRowComponent;



// WEBPACK FOOTER //
// ./app/components/tableGridAccordionRow/tableGridAccordionRow.component.js